/**
 * Timing & Timeouts
 * Network timeouts, UI countdowns, and delay configurations.
 */

// Network & API Timeouts
export const TIMEOUTS = {
    OTP_EXPIRY_SECONDS: 60, // 5 minutes
    REQUEST_TIMEOUT_MS: 30000, // 30 seconds
    RETRY_DELAY_MS: 1000,
    MAX_RETRIES: 3,

    // Extended timeouts (from AI config)
    UPLOAD_TIMEOUT_MS: 60000,
    LONG_POLLING_TIMEOUT_MS: 120000,
} as const;

// UI Countdowns & Delays
export const TIMING = {
    // Countdown timers (in seconds)
    OTP_RESEND_COOLDOWN: 60,
    PASSWORD_RESET_COOLDOWN: 60,
    RECOVERY_REQUEST_COOLDOWN: 300,

    // Auto-redirect delays (in milliseconds)
    SUCCESS_REDIRECT_DELAY: 10000,
    SSO_REDIRECT_DELAY: 3000,
    ERROR_REDIRECT_DELAY: 2000,

    // Polling intervals
    RECOVERY_STATUS_POLL_INTERVAL: 5000,

    // Warning thresholds
    TOKEN_EXPIRY_WARNING_THRESHOLD: 300,
} as const;
